const dockEvents = [
	{
		title_fr: 'au <b>Salon International du Bateau de Toronto</b>',
		title_en: 'at the <b>Toronto International Boat Show</b>',
		date_fr: 'du 17 au 25 janvier',
		date_en: 'from January 17th to 25th',
		link: 'https://www.torontoboatshow.com/',
		startDate: new Date('2026-01-17'),
		endDate: new Date('2026-01-25')
	},
	{
		title_fr: 'à l\'<b>Expo Habitat de Québec</b>',
		title_en: 'at the <b>Québec Habitat Expo</b>',
		date_fr: 'du 5 au 8 février',
		date_en: 'from February 5th to 8th',
		link: 'https://expohabitatquebec.com/',
		startDate: new Date('2026-02-05'),
		endDate: new Date('2026-02-08')
	},
	{
		title_fr: 'au <b>Salon du Bateau de Montréal</b>',
		title_en: 'at the <b>Montreal International Boat Show</b>',
		date_fr: 'du 12 au 15 février',
		date_en: 'from February 12th to 15th',
		link: 'https://salondubateau.com/en',
		startDate: new Date('2026-02-12'),
		endDate: new Date('2026-02-15')
	},
	{
		title_fr: 'au <b>Salon du Bateau et Plein-Air d\'Ottawa</b>',
		title_en: 'at the <b>Ottawa Boat & Outdoor Show</b>',
		date_fr: 'du 19 au 22 février',
		date_en: 'from February 19th to 22nd',
		link: 'https://www.ottawabos.ca/',
		startDate: new Date('2026-02-19'),
		endDate: new Date('2026-02-22')
	},
	{
		title_fr: 'à l\'<b>Expo Habitat Saguenay</b>',
		title_en: 'at the <b>Saguenay Expo Habitat</b>',
		date_fr: 'du 5 au 8 mars',
		date_en: 'from March 5th to 8th',
		link: 'https://www.expohabitatsaglac.com/',
		startDate: new Date('2026-03-05'),
		endDate: new Date('2026-03-08')
	},
	{
		title_fr: 'au <b>Salon National Habitation Montréal</b>',
		title_en: 'at the <b>Montreal National Home Show</b>',
		date_fr: 'du 12 au 15 mars',
		date_en: 'from March 12th to 15th',
		link: 'https://www.salonnationalhabitation.com/',
		startDate: new Date('2026-03-12'),
		endDate: new Date('2026-03-15')
	},
	{
		title_fr: 'au <b>Salon Cottage Life de Toronto</b>',
		title_en: 'at the <b>Toronto Spring Cottage Life Show</b>',
		date_fr: 'du 26 au 29 mars',
		date_en: 'from March 26th to 29th',
		link: 'https://shows.cottagelife.com/spring-cottage-life-show/',
		startDate: new Date('2026-03-26'),
		endDate: new Date('2026-03-29')
	},
	{
		title_fr: 'au <b>Salon du Bateau, Chasse et Pêche de Québec</b>',
		title_en: 'at the <b>Québec Boat and Outdoors Show</b>',
		date_fr: 'du 26 au 29 mars',
		date_en: 'from March 26th to 29th',
		link: 'https://www.salonpleinairquebec.ca/',
		startDate: new Date('2026-03-26'),
		endDate: new Date('2026-03-29')
	},
	{
		title_fr: 'à l\'<b>Expo Nature de Chicoutimi</b>',
		title_en: 'at the <b>Chicoutimi Expo Nature</b>',
		date_fr: 'du 9 au 12 avril',
		date_en: 'from April 9th to 12th',
		link: 'https://evenements2m.com/evenement-masse/expo-nature-chicoutimi/',
		startDate: new Date('2026-04-09'),
		endDate: new Date('2026-04-12')
	},
	{
		title_fr: 'au <b>Salon Cottage Life d\'Ottawa</b>',
		title_en: 'at the <b>Ottawa Cottage Life & Backyard Show</b>',
		date_fr: 'du 10 au 12 avril',
		date_en: 'from April 10th to 12th',
		link: 'https://shows.cottagelife.com/ottawa-cottage-life-backyard-show/',
		startDate: new Date('2026-04-10'),
		endDate: new Date('2026-04-12')
	}
];

// Function to get the current or next event
function getCurrentOrNextEvent() {
	const now = new Date();
	now.setHours(0, 0, 0, 0); // Set to start of day for comparison

	// First, try to find an ongoing event
	const ongoingEvent = dockEvents.find(event => {
		const startDate = new Date(event.startDate);
		const endDate = new Date(event.endDate);
		startDate.setHours(0, 0, 0, 0);
		endDate.setHours(23, 59, 59, 999);
		return now >= startDate && now <= endDate;
	});

	if (ongoingEvent) {
		return ongoingEvent;
	}

	// If no ongoing event, find the next upcoming event
	const upcomingEvent = dockEvents.find(event => {
		const startDate = new Date(event.startDate);
		startDate.setHours(0, 0, 0, 0);
		return startDate >= now;
	});

	return upcomingEvent || null;
}

// Initialize the event bar when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
	const eventBar = document.querySelector('.event-bar');
	if (!eventBar) return;

	const event = getCurrentOrNextEvent();
	if (!event) {
		eventBar.style.display = 'none';
		return;
	}

	const link = eventBar.querySelector('a');
	const span = eventBar.querySelector('span');

	if (!link || !span) return;

	// Get language from data attribute or default to English
	const isFrench = eventBar.dataset.locale === 'fr' || document.documentElement.lang === 'fr';

	// Set the link
	link.href = event.link;

	// Set the text based on language
	if (isFrench) {
		span.innerHTML = `Découvrez nos nouveautés ${event.title_fr} ${event.date_fr}`;
	} else {
		span.innerHTML = `Discover our new products ${event.title_en} ${event.date_en}`;
	}
});
